const mutations = {
	setUser(state, data) {
		state.user = data;
	},
	setOrganization(state, data) {
		state.organization = data;
	},
	setDataSets(state, data){
		state.dataSets = data;
	},
	setOrganizationUser(state, data) {
		state.organizationUser = data;
	},
	setBusiness(state, data) {
		state.business = data;
	},
	setNotification(state, data) {
		state.notification = data;
	},
	setAppInformation(state, data){
		state.appInformation = data
	},
	setPaymentInformation(state, data){
		state.paymentInformation = data
	}
};

export default mutations;
